const filter = (function() {
    let allStraps = [];
    let allBuckles = [];

    const strapFilters   = { material: '', color: '' };
    const innerFilters   = { material: '', color: '' };
    const buckleFilters  = { type: '', material: '' };

    // ── Init ──────────────────────────────────────────────────────────────────
    function initStraps()  { allStraps  = api._cache.straps  || []; }
    function initBuckles() { allBuckles = api._cache.buckles || []; }

    // ── Strap filtering ───────────────────────────────────────────────────────
    function getFilteredStraps() {
        return allStraps.filter(s => {
            const mf = s.metafields;
            if (strapFilters.material && mf.strap_material !== strapFilters.material) return false;
            if (strapFilters.color    && mf.strap_color    !== strapFilters.color)    return false;
            return true;
        });
    }

    function getFilteredInnerStraps() {
        return allStraps.filter(s => {
            const mf = s.metafields;
            if (innerFilters.material && mf.strap_material !== innerFilters.material) return false;
            if (innerFilters.color    && mf.strap_color    !== innerFilters.color)    return false;
            return true;
        });
    }

    function setStrapMaterialFilter(material) {
        strapFilters.material = material;
        if (typeof ui !== 'undefined') ui.renderStrapStep();
    }

    function _setStrapMaterialFilterSilent(material) {
        strapFilters.material = material;
    }

    function setInnerStrapMaterialFilter(material) {
        innerFilters.material = material;
        if (typeof ui !== 'undefined') ui.renderInnerStrapColorCards(getFilteredInnerStraps());
    }

    function _setInnerStrapMaterialFilterSilent(material) {
        innerFilters.material = material;
    }

    // ── Buckle filtering ──────────────────────────────────────────────────────
    function getFilteredBuckles() {
        return allBuckles.filter(b => {
            const mf = b.metafields;
            if (buckleFilters.type     && mf.buckle_type     !== buckleFilters.type)     return false;
            if (buckleFilters.material && mf.buckle_material !== buckleFilters.material) return false;
            return true;
        });
    }

    function setBuckleTypeFilter(type) {
        buckleFilters.type = type;
        buckleFilters.material = '';
        if (typeof state !== 'undefined') state.setState('buckleMaterialFilter', '');
        if (typeof ui !== 'undefined') ui.renderBuckleStep();
    }

    function _setBuckleTypeFilterSilent(type) {
        buckleFilters.type = type;
    }

    function setBuckleMaterialFilter(material) {
        buckleFilters.material = material;
        // caller controls re-render
    }

    return {
        initStraps, initBuckles,
        getFilteredStraps, getFilteredInnerStraps, getFilteredBuckles,
        setStrapMaterialFilter, _setStrapMaterialFilterSilent,
        setInnerStrapMaterialFilter, _setInnerStrapMaterialFilterSilent,
        setBuckleTypeFilter, _setBuckleTypeFilterSilent,
        setBuckleMaterialFilter
    };
})();
